/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Collapse element for auth container
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.0.0
 */
import { icons } from '../../../../assets';
import { Collapse, CollapsePanel } from '../../../../components/common';
import GTMOperations from '../../../../modules/analytics/GoogleTagManager/GTMOperations';
import { initTranslation } from '../../../../modules/internationalization/constants';
import { IPageAuthTranslation } from '../../../../modules/internationalization/types';
import {
    AuthCollapseBodyStyle,
    AuthCollapsePanelContainerStyle,
    AuthCollapseTitleStyle,
    AuthCollapseWrapper,
} from './styled/AuthCollapseStyled';

export interface IPageAuthLocaleCollapse {
    translation: IPageAuthTranslation;
}

const onCollapsePanelClick = (isPanelOpen: boolean) => {
    if (isPanelOpen) {
        // GTM: Send click operation on accordion click
        GTMOperations.auth.onAccordionGetAccessClickOperation();
    }
};

const createBody = (body: string) => {
    return { __html: body };
};

const AuthCollapse = (props: IPageAuthLocaleCollapse) =>
    <AuthCollapseWrapper>
        <Collapse
            bodyStyle={AuthCollapseBodyStyle}
            icon={icons.arrowListDownMedium}
            panelContainerStyle={AuthCollapsePanelContainerStyle}
            titleStyle={AuthCollapseTitleStyle}
        >
            <CollapsePanel
                titleValue={props.translation.collapse.title}
                onClick={onCollapsePanelClick}
            >
                <div dangerouslySetInnerHTML={createBody(props.translation.collapse.body)}/>
            </CollapsePanel>
        </Collapse>
    </AuthCollapseWrapper>;

AuthCollapse.defaultProps = {
    translation: initTranslation.pageAuth,
};

export default AuthCollapse;
